import styled from "styled-components";
import { MediaQueries } from "ratel-ui";

export const Banner = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  background: #fff;
  padding: 24px 16px 56px;
  box-sizing: border-box;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1172px;
  background: #fff;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 36px;
  box-sizing: border-box;

  ${MediaQueries.mobile`
    padding: 24px;
    border-radius: 16px;
  `}
`;

export const Title = styled.h2`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 32px;
  line-height: 1.1;
  text-align: center;
  color: #0a0a0a;
  margin: 0;
  max-width: 994px;

  ${MediaQueries.mobile`
    font-size: 22px;
  `}
`;

export const Subtitle = styled.p`
  font-family: "Nunito", sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 1.4;
  text-align: center;
  color: #0a0a0a;
  margin: 0;
`;

export const QrCode = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 20px;
  object-fit: contain;
  background: #fff;
`;

export const QrCodePlaceholder = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 20px;
  background: rgba(10, 10, 10, 0.8);
`;

export const Caption = styled.p`
  font-family: "Nunito", sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 1.5;
  text-align: center;
  color: #0a0a0a;
  margin: 0;

  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }
`;
